import React, { useEffect, useState } from "react";

// intl imports
import { IconButton, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { Caption } from "../workOrderDetails";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";
import TextField from "@material-ui/core/TextField";
import moment from "moment";
import DeleteIcon from "../../common/icons/deleteIcon";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import DatePickerPermit from "../../common/datepicker/datePickerPermit";
import Autocomplete from "@material-ui/lab/Autocomplete";

const labels = defineMessages({
    close: {
        id: "admin.work-order-details.close",
        defaultMessage: "Close",
        description: "Admin work order close text",
    },
    open: {
        id: "admin.work-order-details.open",
        defaultMessage: "Open",
        description: "Admin work order open",
    },
});

// internal UI components
const styles = makeStyles({
    table: {
        minWidth: 1090,
    },
    comments: {
        minWidth: 500,
        width: 500,
    },
    underline: {
        padding: "3px",
        display: "inline-block",
        width: "20%",
    },
    cost: {
        width: 120,
    },
    permitColumn: {
        width: 200,
    },
    descriptionColumn: {
        width: 200,
    },
    dateColumn: {
        width: 200,
    },
    deleteColumn: {
        width: 50,
    },
    errorMsg: {
        color: "red",
    },
    root: {
        "& .MuiOutlinedInput-multiline": {
            padding: "10.5px",
        },
    },
    border: {
        borderBottom: "1px solid #D4D4D4",
        borderTop: "1px solid #D4D4D4",
        paddingBottom: "25px",
    },
    header: {
        boxShadow: "none",
    },
    cell: {
        padding: "4px 8px",
    },
});
const WorkPermitRowEdit = (props) => {
    const [row, setRow] = useState(props.row);
    const tableClasses = styles();
    const [, refreshState] = useState({});
    const [autoCompleteLabel, setAutoCompleteLabel] = useState(null);
    const intl = useIntl();
    const [deleteFlag, setDeleteFlag] = useState(false);

    const statusOptions = [
        { name_en: "Requested", name_fr: "Demandé", permitId: 60 },
        { name_en: "Received", name_fr: "Reçu", permitId: 61 },
    ];

    useEffect(() => {
        if (row) {
            switch (row.status?.id) {
                case 60:
                    row.statusName_en = "Requested";
                    row.statusName_fr = "Demandé";
                    setAutoCompleteLabel(row[`statusName_${intl.locale}`]);
                    return;
                case 61:
                    row.statusName_en = "Received";
                    row.statusName_fr = "Reçu";
                    setAutoCompleteLabel(row[`statusName_${intl.locale}`]);
                    return;
                default:
                    row.statusName_en = "";
                    row.statusName_fr = "";
                    setAutoCompleteLabel(row[`statusName_${intl.locale}`]);
                    return;
            }
        }
    }, [row, intl]);

    const formateDate = (iDate) => (iDate ? moment(iDate).format("YYYY-MM-DD 00:00:00") : "");

    const update = (event, key, isDate) => {
        if (isDate) row[key] = formateDate(event);
        else if (key == "cost") {
            var data = event?.target?.value;
            row[key] = data?.indexOf(".") >= 0 ? data?.substr(0, data?.indexOf(".")) + data?.substr(data?.indexOf("."), 3) : data;
        } else row[key] = event?.target?.value;

        row.dirty = true;
        refreshState({});
    };

    const handleStatusChange = (event, newValue) => {
        setAutoCompleteLabel("");
        row.newStatusId = newValue.permitId;
        row.dirty = true;
    };

    return (
        !deleteFlag && (
            <div className={tableClasses.border}>
                <Table className={tableClasses.table}>
                    <TableHead className={tableClasses.header}>
                        <TableRow>
                            <TableCell align="left" className={tableClasses.permitColumn}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-permit-number-header"
                                        defaultMessage="Permit Number"
                                        description="Admin work order permit number column header"
                                    />
                                </Caption>
                            </TableCell>
                            <TableCell align="left" className={tableClasses.dateColumn}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-requested-header"
                                        defaultMessage="Requested"
                                        description="Admin work order permit requested column header"
                                    />{" "}
                                    *
                                </Caption>
                            </TableCell>
                            <TableCell align="left" className={tableClasses.dateColumn}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-received-header"
                                        defaultMessage="Received"
                                        description="Admin work order permit received column header"
                                    />
                                </Caption>
                            </TableCell>
                            <TableCell align="left" className={tableClasses.dateColumn}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-expires-header"
                                        defaultMessage="Expires"
                                        description="Admin work order permit expires column header"
                                    />
                                </Caption>
                            </TableCell>
                            <TableCell align="left" className={tableClasses.descriptionColumn}>
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-status-header"
                                        defaultMessage="Status"
                                        description="Admin work order permit status column header"
                                    />
                                </Caption>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left">
                                <TextField
                                    required
                                    InputProps={{
                                        inputProps: {
                                            minLength: 1,
                                            maxLength: 30,
                                            style: { padding: "10.5px" },
                                        },
                                    }}
                                    variant="outlined"
                                    fullWidth
                                    value={row.permitNumber}
                                    onChange={(data) => {
                                        update(data, "permitNumber", false);
                                    }}
                                />
                            </TableCell>
                            <TableCell align="left" className={tableClasses.cell}>
                                <DatePickerPermit
                                    variant="outlined"
                                    fullWidth
                                    value={row.requestedDate ? moment(row.requestedDate).toDate() : ""}
                                    onChange={(data) => {
                                        update(data, "requestedDate", true);
                                    }}
                                    error={null}
                                    inputSize="small"
                                    iconSize="small"
                                />
                            </TableCell>
                            <TableCell align="left" className={tableClasses.cell}>
                                <DatePickerPermit
                                    value={row.receivedDate ? moment(row.receivedDate).toDate() : ""}
                                    variant="outlined"
                                    fullWidth
                                    error={null}
                                    inputSize="small"
                                    iconSize="small"
                                    onChange={(dat) => {
                                        update(dat, "receivedDate", true);
                                    }}
                                />
                            </TableCell>
                            <TableCell align="left" className={tableClasses.cell}>
                                <DatePickerPermit
                                    value={row.expirationDate ? moment(row.expirationDate).toDate() : ""}
                                    variant="outlined"
                                    inputSize="small"
                                    iconSize="small"
                                    error={null}
                                    onChange={(dat) => {
                                        update(dat, "expirationDate", true);
                                    }}
                                />
                            </TableCell>
                            <TableCell align="left" className={tableClasses.cell}>
                                <Autocomplete
                                    id="permit-status-choice"
                                    closeText={intl.formatMessage(labels.close)}
                                    openText={intl.formatMessage(labels.open)}
                                    options={statusOptions}
                                    getOptionLabel={(option) => option[`name_${intl.locale}`]}
                                    onChange={handleStatusChange}
                                    // style={{ width: 300 }}
                                    renderInput={(params) => <TextField {...params} size="small" label={autoCompleteLabel} variant="outlined" />}
                                />
                            </TableCell>
                            <TableCell align="left" width={"5px"}>
                                <IconButton
                                    style={{
                                        padding: "unset",
                                    }}
                                    size={"small"}
                                    onClick={() => {
                                        setDeleteFlag(true);
                                        row.deleteFlag = true;
                                        props.handleDelete();
                                    }}>
                                    <DeleteIcon />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
                <TableHead>
                    <TableRow>
                        <TableCell align="left" className={tableClasses.cost}>
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.permit-details-title-cost-header"
                                    defaultMessage="Cost"
                                    description="Admin work order permit cost column header"
                                />
                            </Caption>
                        </TableCell>
                        <TableCell align="left">
                            <Caption>
                                <FormattedMessage
                                    id="admin.work-order-details.wo-info.permit-details-title-invoice-header"
                                    defaultMessage="Invoice"
                                    description="Admin work order permit invoice column header"
                                />
                            </Caption>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell align="left" className={tableClasses.cost}>
                            <div style={{ display: "block" }}>
                                <TextField
                                    className={tableClasses.underline}
                                    InputProps={{
                                        disableUnderline: true,
                                        readOnly: true,
                                    }}
                                    value={" $"}
                                />

                                <TextField
                                    style={{ display: "inline-block", width: "60%" }}
                                    required
                                    InputProps={{
                                        readOnly: false,
                                        inputProps: {
                                            minLength: 1,
                                            maxLength: 10,
                                            style: { padding: "10.5px" },
                                        },
                                    }}
                                    variant="outlined"
                                    value={row.cost}
                                    onChange={(data) => {
                                        update(data, "cost", false);
                                    }}
                                />
                            </div>
                        </TableCell>
                        <TableCell align="left">
                            <TextField
                                required
                                InputProps={{
                                    readOnly: false,
                                    inputProps: {
                                        minLength: 1,
                                        maxLength: 20,
                                        style: { padding: "10.5px" },
                                    },
                                }}
                                variant="outlined"
                                fullWidth
                                value={row.invoiceNumber}
                                onChange={(data) => {
                                    update(data, "invoiceNumber", false);
                                }}
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left">
                                <Caption>
                                    <FormattedMessage
                                        id="admin.work-order-details.wo-info.permit-details-title-comment-header"
                                        defaultMessage="Comment"
                                        description="Admin work order permit comment column header"
                                    />
                                </Caption>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell align="left" className={tableClasses.comments}>
                                <TextField
                                    InputProps={{
                                        inputProps: {
                                            minLength: 1,
                                            maxLength: 250,
                                        },
                                    }}
                                    multiline
                                    textareastyle
                                    maxRows={6}
                                    required
                                    variant="outlined"
                                    fullWidth
                                    value={row.remarks}
                                    onChange={(data) => {
                                        update(data, "remarks", false);
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div>
        )
    );
};

export default WorkPermitRowEdit;
